export default function PersonIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      id="Regular"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 48}
      height={height ? height : width ? width : 48}
      viewBox="0 -1 48 49"
    >
      <g
        transform="matrix(2,0,0,2,0,0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
      >
        <circle cx="12" cy="3.75" r="3"></circle>
        <path d="M17.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H9l.75,7.5h4.5l.75-7.5h2.25Z"></path>
        <line x1="12" y1="8.25" x2="12" y2="14.25"></line>
      </g>
    </svg>
  );
}
